import Back from '@/assets/invite/back.png';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import { cashRecord } from '@/api/user';
export default {
  name: 'CashRecord',

  setup() {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';
    const router = useRouter();
    const list = ref([]);
    const finished = ref(false);
    const loading = ref(false);
    const refreshing = ref(false);
    const param = ref({
      pageNo: 1,
      pageSize: 20
    });

    const status = val => {
      switch (val) {
        case 1:
          return '已通过';

        case 2:
          return '未通过';

        default:
          return '待审核';
      }
    };

    onMounted(() => {
      cashRecord(param.value).then(res => {
        if (res.code === 0) {
          list.value = res.data.list;

          if (res.data.list.length === 0 || res.data.pageSize < param.value.pageSize) {
            finished.value = true;
          }
        }
      });
    });

    const onRefresh = () => {
      refreshing.value = false;
      param.value.pageNo = 1;
      cashRecord(param.value).then(res => {
        if (res.code === 0) {
          list.value = res.data.list;
        }

        if (res.data.list.length === 0 || res.data.pageSize < param.value.pageSize) {
          finished.value = true;
        }
      }).finally(() => refreshing.value = false);
    };

    const onLoad = () => {
      loading.value = true;
      param.value.pageNo++;
      cashRecord(param.value).then(res => {
        if (res.code === 0) {
          list.value = [...list.value, ...res.data.list];

          if (res.data.list.length === 0 || res.data.pageSize < param.value.pageSize) {
            finished.value = true;
          }
        }
      }).finally(() => loading.value = false);
    };

    return {
      router,
      Back,
      finished,
      loading,
      onLoad,
      onRefresh,
      list,
      refreshing,
      status
    };
  }

};